(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.nav-dropdown').forEach(function (dd) {
    var btn = dd.querySelector('.nav-dropdown__trigger');
    if (!btn) return;

    function closeAll() {
      document.querySelectorAll('.nav-dropdown.is-open').forEach(function (open) {
        open.classList.remove('is-open');
        var b = open.querySelector('.nav-dropdown__trigger');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    btn.addEventListener('click', function (event) {
      event.stopPropagation();
      var willOpen = !dd.classList.contains('is-open');
      closeAll();
      if (willOpen) {
        dd.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.nav-dropdown.is-open').forEach(function (dd) {
      dd.classList.remove('is-open');
      var b = dd.querySelector('.nav-dropdown__trigger');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.product-page__thumb');
    if (!thumb) return;
    var media = thumb.closest('.product-page__media');
    var mainImg = media.querySelector('#ProductMainImage');
    if (mainImg && thumb.dataset.imageUrl) {
      // srcset takes priority over src when both are present on an <img>,
      // so it must be updated too or the browser keeps showing the old image.
      mainImg.src = thumb.dataset.imageUrl;
      if (thumb.dataset.imageSrcset) {
        mainImg.srcset = thumb.dataset.imageSrcset;
      } else {
        mainImg.removeAttribute('srcset');
      }
    }
    media.querySelectorAll('.product-page__thumb.is-active').forEach(function (active) {
      active.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-page"]) return;
  try {
    
  (function () {
    var card = document.getElementById('quizCard');
    var progressBar = document.getElementById('quizProgressBar');
    var progressLabel = document.getElementById('quizProgressLabel');
    var dataEl = document.getElementById('quizProductData');
    if (!card || !dataEl) return;

    var products = JSON.parse(dataEl.textContent);

    var questions = [
      {
        id: 'size',
        icon: '📏',
        heading: "How big is your pup?",
        options: [
          { value: 'small', icon: '🐕', label: 'Small (under 20 lbs)' },
          { value: 'medium', icon: '🐶', label: 'Medium (20-50 lbs)' },
          { value: 'large', icon: '🐕‍🦺', label: 'Large (50+ lbs)' }
        ]
      },
      {
        id: 'goal',
        icon: '🎯',
        heading: 'What are you treating for?',
        options: [
          { value: 'training', icon: '🎓', label: 'Training & rewards' },
          { value: 'snack', icon: '🍪', label: 'Everyday snacking' },
          { value: 'longlasting', icon: '🦴', label: 'Long-lasting chew' },
          { value: 'topper', icon: '🥣', label: 'Meal topper / boost' }
        ]
      },
      {
        id: 'flavor',
        icon: '😋',
        heading: 'What flavor does your pup love?',
        options: [
          { value: 'peanut', icon: '🥜', label: 'Peanut butter' },
          { value: 'meat', icon: '🥩', label: 'Meaty & savory' },
          { value: 'veggie', icon: '🥕', label: 'Veggie & fruity' },
          { value: 'any', icon: '🐤', label: 'Anything goes!' }
        ]
      },
      {
        id: 'vibe',
        icon: '✨',
        heading: 'Pick a vibe',
        options: [
          { value: 'variety', icon: '🎁', label: 'Surprise me — a little of everything' },
          { value: 'single', icon: '💯', label: 'Just one perfect treat' }
        ]
      }
    ];

    // Ported 1:1 from the Lovable site's Quiz.tsx recommendHandle(). Never
    // returns pig ears. Keep in sync with the product data captured above.
    function recommendHandle(a) {
      if (a.vibe === 'variety') {
        if (a.goal === 'training') return 'little-bites-bundle-1';
        if (a.goal === 'longlasting') return 'the-protein-pack-1';
        return 'the-bork-box-1';
      }

      if (a.goal === 'longlasting') {
        if (a.size === 'small') return 'chicken-feet';
        return 'the-protein-pack-1';
      }

      if (a.goal === 'topper') {
        if (a.flavor === 'meat') return 'bork-beef-liver-chips';
        if (a.flavor === 'veggie') return 'heartbeet-cookies';
        if (a.flavor === 'peanut') return 'bork-mini-peanut-butter-bones';
        return 'little-bites-bundle-1';
      }

      if (a.goal === 'training') {
        if (a.flavor === 'peanut') return 'bork-peanut-butter-training-bites';
        if (a.flavor === 'meat') return 'chicken-hearts';
        if (a.flavor === 'veggie') return 'bork-mini-pumpkin-bones';
        return 'little-bites-bundle-1';
      }

      if (a.flavor === 'peanut') {
        return a.size === 'small' ? 'bork-mini-peanut-butter-bones' : 'bork-peanut-butter-dog-bones';
      }

      if (a.flavor === 'meat') {
        return a.size === 'large' ? 'the-protein-pack-1' : 'bork-beef-liver-chips';
      }

      if (a.flavor === 'veggie') {
        return a.size === 'small' ? 'bork-mini-pumpkin-bones' : 'heartbeet-cookies';
      }

      return a.size === 'large' ? 'the-bork-box-1' : 'little-bites-bundle-1';
    }

    var answers = {};
    var step = 0;

    function updateProgress() {
      if (step >= questions.length) {
        progressBar.style.width = '100%';
        progressLabel.textContent = 'Done!';
      } else {
        progressBar.style.width = Math.round(((step + 1) / questions.length) * 100) + '%';
        progressLabel.textContent = 'Question ' + (step + 1) + ' of ' + questions.length;
      }
    }

    function pickProduct() {
      var handle = recommendHandle(answers);
      return products[handle] || products['the-bork-box-1'];
    }

    function renderQuestion() {
      var q = questions[step];
      var html = '<div class="quiz-step__icon">' + q.icon + '</div>';
      html += '<h2 class="quiz-step__heading">' + q.heading + '</h2>';
      html += '<div class="quiz-step__options">';
      q.options.forEach(function (opt) {
        html += '<button type="button" class="quiz-option comic-border" data-value="' + opt.value + '">' +
          '<span class="quiz-option__label"><span>' + opt.icon + '</span><span>' + opt.label + '</span></span>' +
          '<span>→</span></button>';
      });
      html += '</div>';
      if (step > 0) {
        html += '<button type="button" class="quiz-page__back" id="quizBack">← Back</button>';
      }
      card.innerHTML = html;

      card.querySelectorAll('.quiz-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          answers[q.id] = btn.dataset.value;
          step += 1;
          if (step >= questions.length) {
            renderResult();
          } else {
            renderQuestion();
          }
          updateProgress();
        });
      });
      var backBtn = document.getElementById('quizBack');
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          step = Math.max(0, step - 1);
          renderQuestion();
          updateProgress();
        });
      }
    }

    function renderResult() {
      var product = pickProduct();
      var html = '<div class="quiz-result__emoji">🎉</div>';
      html += '<div class="quiz-result__eyebrow">Your Match</div>';
      html += '<h2 class="quiz-result__title">' + product.title + '</h2>';
      html += '<div class="quiz-result__price">' + product.price + '</div>';
      if (product.image) {
        html += '<img src="' + product.image + '" alt="' + product.title + '" class="quiz-result__image">';
      }
      html += '<p class="quiz-result__description">' + product.description + '</p>';
      html += '<div class="quiz-result__actions">' +
        '<a href="' + product.url + '" class="btn btn--primary comic-shadow comic-press">Shop this treat</a>' +
        '<button type="button" class="quiz-result__retake" id="quizRetake">Retake quiz</button>' +
        '</div>';
      card.innerHTML = html;

      document.getElementById('quizRetake').addEventListener('click', function () {
        step = 0;
        answers = {};
        renderQuestion();
        updateProgress();
      });
    }

    renderQuestion();
    updateProgress();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="testimonials-track-"]').forEach(function (track) {
    var carousel = track.closest('.testimonials__carousel');
    var paused = false;
    var resumeTimer;

    function pause() {
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
      }, 5000);
    }

    function step(direction) {
      var card = track.querySelector('.testimonial-card');
      if (!card) return;
      var amount = card.getBoundingClientRect().width + 24;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var atStart = track.scrollLeft <= 4;
      var left = amount;
      if (direction === 'next') {
        left = atEnd ? -track.scrollLeft : amount;
      } else if (direction === 'prev') {
        left = atStart ? track.scrollWidth - track.clientWidth : -amount;
      }
      track.scrollBy({ left: left, behavior: 'smooth' });
    }

    track.addEventListener('pointerdown', pause);
    track.addEventListener('wheel', pause, { passive: true });
    track.addEventListener('touchstart', pause, { passive: true });

    if (carousel) {
      carousel.querySelectorAll('.testimonials__arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          pause();
          step(btn.dataset.direction);
        });
      });
    }

    setInterval(function () {
      if (paused) return;
      step('next');
    }, 4000);
  });

  } catch(e) { console.error(e); }
})();
})();
